/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../bar-DYRrVa7n.js";
import { r as t } from "../../scene-8VKOJsMP.js";
import { r as n, t as r } from "../../rule-BbeXdbtC.js";
import { n as i, t as a } from "../../mark-decorative-B0-tbEeT.js";
import { d as o, g as s, p as c, u as l } from "../../shared-CfvkKPnq.js";
import "../../weather-icon-CYo2v_7U.js";
import { formatDecimal as u, formatHour as d, formatPercent as f } from "../format.js";
import { i as p, n as m, r as h, t as g } from "../../theme-BDdgxk0M.js";
import { html as _ } from "lit";
// src/charts/presets/weather.ts
var v = {
	left: 44,
	right: 12
}, y = [
	{
		icon: "thermometer-celsius",
		label: "Temperatur",
		text: (e) => `${u(e.temperature)} °C`
	},
	{
		icon: "raindrop-measure",
		label: "Niederschlag",
		text: (e) => `${u(e.precipitation)} mm`
	},
	{
		icon: "umbrella",
		label: "Regenwahrscheinlichkeit",
		text: (e) => f(e.precipitationProbability / 100)
	}
];
function b(f, _) {
	let b = Math.max(5, ...f.map((e) => e.precipitation)), x = (e) => e.datum;
	return t({
		theme: h,
		margin: v,
		marks: [
			a(e(f, {
				x: "time",
				y: "precipitation",
				yScale: "precipitation",
				fill: m[0],
				inset: 1,
				radius: { end: 2 }
			})),
			a(n(f, {
				x: "time",
				y: "precipitationProbability",
				yScale: "probability",
				stroke: m[3],
				strokeWidth: 1.5,
				strokeDasharray: "3 3",
				curve: l
			})),
			n(f, {
				x: "time",
				y: "temperature",
				stroke: m[2],
				strokeWidth: 2,
				curve: l
			}),
			..._ ? [r([_], {
				stroke: g.negative,
				strokeDasharray: "4 3"
			})] : [],
			i({
				x: !0,
				y: !1,
				stroke: g.axis,
				strokeDasharray: "3 3"
			})
		],
		scales: {
			x: {
				scale: s,
				axis: { ticks: {
					count: 5,
					format: d
				} }
			},
			y: o((e) => `${u(e)}°`),
			precipitation: {
				channel: "y",
				scale: c().domain([0, b]),
				axis: !1
			},
			probability: {
				channel: "y",
				scale: c().domain([0, 100]),
				axis: !1
			}
		},
		focus: "nearest-x",
		maxFocusDistance: Infinity,
		focusRing: !1,
		tooltip: p({ items: [{
			id: "time",
			label: "",
			text: (e) => d(e.xValue)
		}, ...y.map(({ label: e, text: t }) => ({
			id: e,
			label: e,
			text: (e) => t(x(e))
		}))] })
	});
}
function x({ defaultBody: e, primaryPoint: t, points: n }) {
	let r = (t ?? n[0])?.datum;
	return r ? _`<div
        style="display: grid; grid-template-columns: auto 1fr auto; align-items: center; gap: 0.2em 0.5em;"
    >
        ${r.icon ? _`<ptc-ui-weather-icon style="font-size: 1.5em;" .icon=${r.icon}></ptc-ui-weather-icon>
                  <span>${r.conditions}</span>` : _`<span></span><span></span>`}
        <span style="text-align: end;">${d(r.time)}</span>
        ${y.map(({ icon: e, label: t, text: n }) => _`<ptc-ui-weather-icon .icon=${e}></ptc-ui-weather-icon>
                    <span>${t}</span>
                    <span style="text-align: end; font-variant-numeric: tabular-nums;">${n(r)}</span>`)}
    </div>` : e;
}
export { b as weatherChart, v as weatherGutter, x as weatherTooltip };

//# sourceMappingURL=weather.js.map